export default __webpack_public_path__ + "static/Evaluate-and-Improve-0e3b9045afaf57c1f51d791fd70f7487.webp";